import React, { useEffect } from "react";
import { StyledCreateHolidayContainer } from "./styles";
import Input from "../UI/Input";
import { DatePickerInput } from "../UI/DatePicker";
import Button from "../UI/Button";
import { translate } from "../../utils/translations/translate";
import { useFormik } from "formik";
import { HolidayValidationSchema } from "./schema";
import moment from "moment";
import dayjs from "dayjs";
import { isCurrentYear } from "../../utils/helpers";
const currentYear = dayjs().year();
const minDate = dayjs().startOf("week").subtract(1, 'week');
const maxDate = dayjs(`${currentYear}-12-31`);
export const CreateEditHoliday = ({ isCreateMode, savedData, onSave }) => {
  const formik = useFormik({
    initialValues: {
      holidayDate: "",
      holidayName: "",
      holidayDescription: "",
      holidayId: "",
    },
    validationSchema: HolidayValidationSchema,
    onSubmit: (values) => {
      onSave(values);
    }
  });
  const { setValues } = formik
  const { holidayDate, holidayDescription, holidayName } = formik.values;
  const formTitle = isCreateMode
    ? translate("labels.createHoliday")
    : translate("labels.editHoliday");
  const buttonText = isCreateMode
    ? translate("labels.createHoliday")
    : translate("labels.saveChanges");
  useEffect(() => {
    if (savedData && typeof savedData === "object" && savedData.holidayId) {
      setValues(savedData);
    }
  }, [savedData, setValues])
  return (
    <StyledCreateHolidayContainer>
      <h1 className="tma_form_title">{formTitle}</h1>
      <form className="tma_holiday_create_form" onSubmit={formik.handleSubmit}>
        <div className="tma_input_control">
          <Input
            labelText={translate("labels.name")}
            id="holidayName"
            name="holidayName"
            inputProps={{ maxLength: 50 }}
            placeholder={translate("labels.holidayName")}
            value={holidayName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.holidayName && Boolean(formik.errors.holidayName)
            }
            helperText={formik.touched.holidayName && formik.errors.holidayName}
          />
        </div>
        <div className="tma_input_control">
          <DatePickerInput
            labelText={translate("labels.holidayDate")}
            id="holidayDate"
            name={"holidayDate"}
            value={holidayDate}
            disablePast={false}
            minDate={minDate}
            maxDate={maxDate}
            disabled={(!isCreateMode && !isCurrentYear(holidayDate))}
            onChange={(newDate) => {
              formik.setFieldValue(
                "holidayDate",
                moment(newDate).format("YYYY-MM-DD")
              );
            }}
            onBlur={formik.handleBlur}
            error={
              formik.touched.holidayDate && Boolean(formik.errors.holidayDate)
            }
            helperText={formik.touched.holidayDate && formik.errors.holidayDate}
          />
        </div>
        <div className="tma_input_control">
          <Input
            labelText={translate("labels.description")}
            id="holidayDescription"
            name="holidayDescription"
            placeholder={translate("labels.holidayDescription")}
            value={holidayDescription}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            inputProps={{ maxLength: 100 }}
            error={
              formik.touched.holidayDescription &&
              Boolean(formik.errors.holidayDescription)
            }
            helperText={
              formik.touched.holidayDescription &&
              formik.errors.holidayDescription
            }
          />
        </div>
        <div className="tma_form_actions">
          <Button
            className={"tma_create_holiday_submit"}
            type="submit"
            text={buttonText}
          />
        </div>
      </form>
    </StyledCreateHolidayContainer>
  );
};
